import { StatoOrdine } from "./models";
import { SemanticCOLORS, SemanticICONS } from "semantic-ui-react";

export interface StatoValues {
    stato: StatoOrdine,
    name: SemanticICONS,
    color: SemanticCOLORS,
    text: string
}

export function getStatoValues(stato: StatoOrdine): StatoValues {
    switch (stato) {
        case StatoOrdine.Inviato:
            return { stato: StatoOrdine.Inviato, name: 'send', color: 'teal', text: 'Inviato' };
        case StatoOrdine.PresoInCarico:
            return { stato: StatoOrdine.PresoInCarico, name: 'unhide', color: 'yellow', text: 'In carico' };
        case StatoOrdine.InCorso:
            return { stato: StatoOrdine.InCorso, name: 'play', color: 'blue', text: 'In corso' };
        case StatoOrdine.Chiuso:
            return { stato: StatoOrdine.Chiuso, name: 'checkmark box', color: 'green', text: 'Chiuso' };
        case StatoOrdine.Rifiutato:
            return { stato: StatoOrdine.Rifiutato, name: 'window close outline', color: 'red', text: 'Rifiutato' };
    }
}

export const allStatiValues: StatoValues[] = [
    { stato: StatoOrdine.Inviato, name: 'send', color: 'teal', text: 'Inviato' },
    { stato: StatoOrdine.PresoInCarico, name: 'unhide', color: 'yellow', text: 'In carico' },
    { stato: StatoOrdine.InCorso, name: 'play', color: 'blue', text: 'In corso' },
    { stato: StatoOrdine.Chiuso, name: 'checkmark box', color: 'green', text: 'Chiuso' },
    { stato: StatoOrdine.Rifiutato, name: 'window close outline', color: 'red', text: 'Rifiutato' }
]
